import { PageType } from "@product/scmp-sdk";

import type { AppBarVariant } from "~/components/app-bar/helpers";

export const pathname = "/sub-section";

export const page = {
  route(
    query: QueryParameters<{
      appBarVariant?: AppBarVariant;
      entityId: string;
      name?: string;
    }>,
  ) {
    return {
      pathname,
      query: { ...query, pageType: PageType.Section },
    };
  },
};
